import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AutoUnsubscribe} from "../../../fw/decoractors/AutoUnsubscribe";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {DtoWorkhourOverview} from "./models/DtoWorkhourOverview";
import {PageHeaderBarConfig, PageSubheaderBarConfig} from "../../../fw/pages/page-config-api";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {BreadcrumService, BreadcrumStep} from "../../../fw/services/breadcrum.service";
import {EmployeeHouroverviewService} from "./employee-houroverview.service";
import {FormService} from "../../../fw/services/form.service";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoEmployeeName} from "../../shared/models/DtoEmployeeName";

@AutoUnsubscribe()
@Component({
    selector: 'ngx-employee-houroverview',
    template: require('./employee-houroverview.component.html'),
    styles: [require('./employee-houroverview.component.css')]
})
export class EmployeeHouroverviewComponent implements OnInit {
    @ViewChild('grid', {static: false})
    grid: DynamicGridComponent;
    form: FormGroup = this.fb.group({
        year: this.ss.getCurrentYear(),
        period: 0,
        employeeId: 0,
        showFuture: false,
        from: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate()),
        untill: this.ss.getLastDayOfMonth(this.ss.getCurrentDate())
    });
    data: DtoWorkhourOverview[];
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'INSTELLINGEN',
        buttonDefinition: [
            {
                description: 'BEKIJKEN',
                isSmall: false,
                clickEventType: 'search'
            }
        ]
    };
    pshbConfig: PageSubheaderBarConfig = {
        title: 'URENOVERZICHT',
        buttonDefinition: [
            {
                description: 'EXPORTEREN',
                clickEventType: 'export',
                isSmall: false
            }
        ]
    };
    employeeOverviewColumnDefinition: Array<ColumnDefinition> = [
        {
            label: 'Medewerker',
            type: 'string',
            width: '*',
            key: 'employee'
        },
        {
            label: 'Contract',
            type: 'number',
            width: '*',
            key: 'contract'
        },
        {
            label: 'Ziek',
            type: 'number',
            width: '*',
            key: 'sick'
        },
        {
            label: 'Verlof',
            type: 'number',
            width: '*',
            key: 'paidAbsence'
        },
        {
            label: 'Opname TVT',
            type: 'number',
            width: '*',
            key: 'tvt'
        },
        {
            label: 'BG Verlof',
            type: 'number',
            width: '*',
            key: 'unpaidAbsence'
        },
        {
            label: 'Overwerken',
            type: 'number',
            width: '*',
            key: 'extra'
        },
        {
            label: 'Van filiaal',
            type: 'number',
            width: '*',
            key: 'transferFrom'
        },
        {
            label: 'Naar filiaal',
            type: 'number',
            width: '*',
            key: 'transferTo'
        },
        {
            label: 'Aanwezig',
            type: 'number',
            width: '*',
            key: 'present'
        }
    ];
    yesNoItems: Array<{ text: string; value: boolean }> = [
        {text: 'Ja', value: true},
        {text: 'Nee', value: false}
    ];
    periods: Array<{ text: string; value: number }> = [
        {text: 'Maand', value: 0},
        {text: 'Week', value: 1},
        {text: 'Dag', value: 2}
    ];
    years: Array<{ text: string; value: number }> = [];
    employees: DtoEmployeeName[];
    excelFilename: string = `MijnSalon urenoverzicht.xlsx`;

    constructor(private breadcrumService: BreadcrumService,
                private ds: EmployeeHouroverviewService,
                private fb: FormBuilder,
                private fs: FormService,
                private ss: SharedService,
                private sds: SharedDataService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            {text: 'hoofdmenu', isLastStep: false},
            {text: 'medewerkers', isLastStep: false},
            {text: 'urenoverzicht', isLastStep: true}
        ];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        for (let i = 0; i < 5; i++) {
            this.years.push({
                text: (this.ss.getCurrentYear() - i).toString(),
                value: this.ss.getCurrentYear() - i
            });
        }

        this.form.get('year').valueChanges.subscribe(() => {
            this.loadData();
        });
        this.form.get('period').valueChanges.subscribe(() => {
            this.loadData();
        });
        this.form.get('employeeId').valueChanges.subscribe(() => {
            this.loadData();
        });
        this.form.get('showFuture').valueChanges.subscribe(() => {
            this.loadData();
        });
        this.form.get('from').valueChanges.subscribe(() => {
            this.loadData();
        });
        this.form.get('untill').valueChanges.subscribe(() => {
            this.loadData();
        });

        this.sds.getActiveEmployeesWithAll().subscribe((res: DtoEmployeeName[]) => {
            this.employees = res;
            setTimeout(() => {
                this.loadData();
            });
        });
    }

    loadData() {
        this.grid.clearData();
        this.data = null;
        this.ds.getOverview({
            employeeId: this.form.get('employeeId').value,
            from: this.form.get('from').value,
            period: this.form.get('period').value,
            showCurrentMonth: this.form.get('showFuture').value,
            untill: this.form.get('untill').value,
            year: this.form.get('year').value
        }).subscribe((res: DtoWorkhourOverview[]) => {
            this.data = res;
            this.grid.showData(this.data);
        });
    }

    showDateSelection() {
        return this.form && this.form.get('period').value === 2;
    }

    phbBtnClicked(event): void {
        if (event === 'search') this.loadData();
    }

    pshbBtnClicked(event): void {
        if (event === 'export') {
            this.grid.saveAsExcel();
        } else if (event === 'print') {

        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/employees/employee-houroverview/employee-houroverview.component.ts